import { transportInfo, venue } from '@/mocks/wedding';

const PANEL_BG =
  'https://readdy.ai/api/search-image?query=Warm%20evening%20exterior%20of%20an%20elegant%20city%20wedding%20venue%20with%20soft%20lit%20windows%20and%20trees%2C%20dusk%20cinematic%20photography%2C%20muted%20warm%20brown%20tones%2C%20quiet%20urban%20mood&width=2400&height=1350&seq=wed-panel-map&orientation=landscape';

export default function MapPanel() {
  return (
    <section className="panel" data-side="left" id="map">
      <img className="panel-bg" src={PANEL_BG} alt="해질녘 예식장 외관" data-parallax="0.32" />
      <div className="panel-veil" aria-hidden="true" />

      <div className="map-split">
        <div className="panel-copy" data-parallax="-0.08">
          <p className="stamp" data-reveal>
            05 — 오시는 길
          </p>
          <h2 data-reveal>
            오시는 길을
            <br />
            <em className="accent">미리</em> 안내드려요
          </h2>
          <p className="sub" data-reveal>
            {venue.name} {venue.hall} · {venue.address}
          </p>
          <ul className="info-list">
            {transportInfo.map((row) => (
              <li key={row.label} data-reveal>
                <span>{row.label}</span>
                <span className="whitespace-pre-line">{row.value}</span>
              </li>
            ))}
          </ul>
          <a className="cta" href={venue.mapLink} target="_blank" rel="noopener noreferrer" data-reveal>
            지도에서 길찾기
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="map-frame" data-reveal>
          <iframe
            title="예식장 위치 지도"
            src={venue.mapEmbed}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}